import React, { useContext } from 'react';
import { useLocation, Link } from 'react-router-dom';
import styles from './styles.module.css';
import CartIcon from '../../icons/cart.png';
import ProfileIcon from '../../icons/profile.png';
import HomeIcon from '../../icons/home.png';
import CartFillIcon from '../../icons/cartFill.png';
import ProfileFillIcon from '../../icons/profileFill.png';
import HomeFIllIcon from '../../icons/homeFill.png';
import { ShopContext } from '../../../contexts/ShopContext';
import { ROUTES } from '../../../const';
import Callicon from '../../icons/call.png';
import CallFillicon from '../../icons/call_fill.png';

function NavBar() {
  const location = useLocation();
  const { shop } = useContext(ShopContext);
  const shopId = shop?.shopId;

  const isActive = (route) => location.pathname === route.replace(':shopId', shopId);

  return (
    <div className={styles.container}>
      <div className={styles.navItemWrapper}>
        <Link className={styles.navItem} to={ROUTES.SHOP_HOME.replace(':shopId', shopId)}>
          <img src={isActive(ROUTES.SHOP_HOME) ? HomeFIllIcon : HomeIcon} alt="Home" />
          <span>Home</span>
        </Link>
        <Link className={styles.navItem} to={ROUTES.CART.replace(':shopId', shopId)}>
          <img src={isActive(ROUTES.CART) ? CartFillIcon : CartIcon} alt="Cart" />
          <span>Cart</span>
        </Link>
        <Link className={styles.navItem} to={ROUTES.PROFILE.replace(':shopId', shopId)}>
          <img src={isActive(ROUTES.PROFILE) ? ProfileFillIcon : ProfileIcon} alt="Profile" />
          <span>Profile</span>
        </Link>
        <Link className={styles.navItem} to={ROUTES.CONTACT_US.replace(':shopId', shopId)}>
          <img src={isActive(ROUTES.CONTACT_US) ? CallFillicon : Callicon} alt="Profile" />
          <span>Contact</span>
        </Link>
      </div>
    </div>
  );
}

export default NavBar;
